import { html, TemplateResult } from "lit-html";
import { getTestId } from "Services/test-ids/TestIdHelper";
import { TestIdDictionary } from "Services/test-ids/TestIdDictionary";
import { useMemo } from "Shared/haunted/CustomHooks";
import classNames from "classnames";

export interface ErrorMessageProps {
	errorMessage: string | TemplateResult | (string | TemplateResult)[];
	errorMessageDataTestCode?: string;
	verticalGap?: boolean;
}

export const useErrorMessage = (props: ErrorMessageProps) => {
	const displayedErrors = useMemo<(string | TemplateResult)[]>(
		() => (Array.isArray(props.errorMessage) ? props.errorMessage : [props.errorMessage]).filter((error) => error),
		[props.errorMessage]
	);

	const htmlTemplate = () =>
		displayedErrors.length
			? html`
					<div class=${classNames("w-full text-center", { "my-4 sm:my-0": props.verticalGap })}>
						${displayedErrors.map(
							(error) => html`
								<span
									class="mx-auto mb-5 mt-2 inline-block rounded-md bg-[#e299a1] px-6 py-3 text-sm text-[#163a6f]"
									data-test-id=${getTestId(TestIdDictionary.Common.FormFieldError, {
										c: props.errorMessageDataTestCode,
									})}
								>
									${error}
								</span>
							`
						)}
					</div>
			  `
			: "";

	return { htmlTemplate };
};
